module.exports = __webpack_public_path__ + "static/media/payment-bni.f5fde1f7.png";